var $ = require('jquery');
var ajax = require('../utils/ajax');
var cookie = require('./cookie');

var POP_UP_DISABLING_COOKIE_NAME = 'disableGeoIPCountrySwitcher';
var PROHIBITED_NAMESPACES = ['countryselection', 'checkout'];

/**
 * @description Get pop up content from the server and put it to the wrapper
 * @returns {void}
 */
function createPopUp() {
    var $popUpContainer = $('.js-country-switcher');

    if ($popUpContainer.length === 0) {
        return;
    }

    ajax.getJson({
        url: $popUpContainer.data('url'),
        data: {
            originURL: window.Urls.requestHttpURL
        },
        callback: function (data) {
            if (!data || !data.showPopUp) {
                return;
            }

            var delaySeconds = window.SitePreferences.geoIpCountrySwitcherDelay || 1;

            setTimeout(function () {
                $popUpContainer.append(data.content);
                initializePopUpEvents($popUpContainer);
                setCookieForPopUpHiding($popUpContainer.data('requestCountry'));
            }, delaySeconds * 1000);
        }
    });
}

/**
 * @description Initialize pop up events (closing/language changing)
 * @param {object} $popUpContainer - Pop up container jQuery object
 * @returns {void}
 */
function initializePopUpEvents($popUpContainer) {
    var $title = $popUpContainer.find('.js-country-switcher-title');
    var $link = $popUpContainer.find('.js-country-switcher-link');
    var $linkText = $link.find('.js-country-switcher-link-text');

    $popUpContainer.on('click', '.js-country-switcher-close', function () {
        $popUpContainer.remove();
    });

    $link.on('click', function (e) {
        var requestCountry = $popUpContainer.data('requestCountry');
        var originLocale = $popUpContainer.find('.js-country-switcher-lang-option:checked').val();

        e.preventDefault();
        setCookieForPopUpHiding(requestCountry, originLocale).done(function () {
            window.location = $link.attr('href');
        });
    });

    $popUpContainer.on('change', '.js-country-switcher-lang-option', function () {
        var $currentOption = $(this);
        var optionTitle = $currentOption.data('title');
        var optionLink = $currentOption.data('link');
        var optionLinkText = $currentOption.data('linkText');

        $title.text(optionTitle);
        $link.attr('href', optionLink);
        $link.attr('title', optionLinkText);
        $linkText.text(optionLinkText);
    });
}

/**
 * @description Set cookie that disabling pop up for new page request
 * @param {string} requestCountry - Current request country
 * @param {string} originLocale - User location country
 * @returns {Object} The jqXHR Object from ajax request
 */
function setCookieForPopUpHiding(requestCountry, originLocale) {
    var existingCountries = cookie.getJSON(POP_UP_DISABLING_COOKIE_NAME) || {};

    existingCountries[requestCountry] = originLocale || true;
    // 1 year by default with privacy check
    return cookie.set(POP_UP_DISABLING_COOKIE_NAME, JSON.stringify(existingCountries));
}

/**
 * @description Check is pop up enabled for this page:
 * *Is namespace allowed
 * *Is functionality enabled for site
 * @param {string|undefined} ns - Page namespace
 * @returns {void}
 */
function isCountrySwitcherPopupEnabled(ns) {
    var popUpEnabledForSite = window.SitePreferences.enableGeoIpCountrySwitcher;

    return PROHIBITED_NAMESPACES.indexOf(ns) === -1 && popUpEnabledForSite;
}

module.exports = {
    init: function (ns) {
        if (isCountrySwitcherPopupEnabled(ns)) {
            createPopUp();
        }
    }
};
